/**
 * Google Analytics Configuration & Tracking
 * Tracking ID: G-TKB77PKNCK
 */

const GA_TRACKING_ID = 'G-TKB77PKNCK';

/**
 * Track page views - call on route changes
 */
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: path,
    });
  }
};

/**
 * Track custom events
 */
export const trackEvent = (eventName, eventData = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }
};

/**
 * Pre-built engagement tracking
 */
export const trackEngagement = {
  recipeCreated: () => trackEvent('recipe_created'),
  recipeSaved: () => trackEvent('recipe_saved'),
  batchCreated: () => trackEvent('batch_created'),
  upgradeToPro: (billingCycle) => trackEvent('upgrade_to_pro', { billing_cycle: billingCycle }),
  signUp: (method) => trackEvent('sign_up', { method }),
  login: (method) => trackEvent('login', { method }),
  calculatorUsed: (lyeType) => trackEvent('calculator_used', { lye_type: lyeType }),
};

/**
 * Set user properties after login
 */
export const setUserProperties = (userId, plan) => {
  if (window.gtag) {
    window.gtag('config', GA_TRACKING_ID, { user_id: userId });
    window.gtag('set', 'user_properties', { user_plan: plan });
  }
};

export default { trackPageView, trackEvent, trackEngagement, setUserProperties, GA_TRACKING_ID };
